import {use} from 'react'
import {SidebarExpandIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {
  useContentPreviewActions,
  useContentPreviewOpen,
  // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Reuse the existing workbench state.
} from '@github-ui/copilot-immersive-v1/components/ContentPreview/ContentPreviewContext'

import {AgentsWorkbenchCloseContext, AgentsWorkbenchContext} from './AgentsWorkbenchContext'

export function AgentsWorkbenchToggle() {
  const enabled = use(AgentsWorkbenchContext)
  return enabled ? <WorkbenchToggle /> : null
}

function WorkbenchToggle() {
  const isOpen = useContentPreviewOpen()
  const {openPreviewPane, closePreviewPane, returnFocusElementRef} = useContentPreviewActions()
  const onClose = use(AgentsWorkbenchCloseContext)

  return (
    <IconButton
      icon={SidebarExpandIcon}
      aria-label={isOpen ? 'Close workbench' : 'Open workbench'}
      aria-expanded={isOpen}
      onClick={event => {
        if (isOpen) {
          returnFocusElementRef.current = event.currentTarget
          onClose?.()
          closePreviewPane()
        } else openPreviewPane(event.currentTarget)
      }}
    />
  )
}
